/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import BaseCom from "../BaseCom"
import { withParamsAndNavigate } from "../WithParamsAndNavigate";

class Floor extends BaseCom {
    render() {
        return (
            <div className="container-fluid">
                <h1><L>Floor</L></h1>
            </div>
        );
    }
}

export default withParamsAndNavigate(Floor);